/** Matches Postgres uuid text form; rejects empty / malformed (JWT fast-path guard). */
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Align with RLS / UI checks (`jwt_tenant_role()` values). */
const ALLOWED_TENANT_ROLES = new Set(['admin', 'supervisor', 'worker', 'billing', 'operations']);

function normalizeUuid(value) {
  if (value == null) return '';
  const s = typeof value === 'string' ? value.trim() : String(value).trim();
  return UUID_RE.test(s) ? s : '';
}

function normalizeTenantRole(value) {
  if (value == null || typeof value !== 'string') return '';
  const s = value.trim().toLowerCase();
  return ALLOWED_TENANT_ROLES.has(s) ? s : '';
}

/**
 * If JWT app_metadata carries a usable tenant (same rules as tenant_claims_hook), returns membership shape.
 * Otherwise null → caller must load via tenant_memberships (invite pending, platform-only, hook lag).
 */
export function tryGetTenantMembershipFromJwt(user) {
  const meta = user?.app_metadata;
  if (!meta || typeof meta !== 'object') return null;

  const tenantId = normalizeUuid(meta.tenant_id);
  const role = normalizeTenantRole(meta.tenant_role);
  if (!tenantId || !role) return null;

  return { role, tenantId, invitePending: false };
}
